import SchoolIcon from "@mui/icons-material/School";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctoralSchoolCampaigns from "./List";
import CreateDoctoralSchoolCampaign from "./Create";
import EditDoctoralSchoolCampaign from "./Edit";
import ShowDoctoralSchoolCampaign from "./Show";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: `${DoctoralServicePath}doctoral-school-campaigns`,
  title: "Докторантско училище",
  list: <ListDoctoralSchoolCampaigns />,
  create: <CreateDoctoralSchoolCampaign />,
  createPermission: permissions.canCreateDoctoralSchoolCampaigns,
  edit: <EditDoctoralSchoolCampaign />,
  editPermission: permissions.canUpdateDoctoralSchoolCampaigns,
  show: <ShowDoctoralSchoolCampaign />,
  permission: permissions.canPreviewDoctoralSchoolCampaigns,
};
